export const SET_SYNC_HISTORY = 'SET_SYNC_HISTORY';
export const SET_SYNC_HISTORY_LOADING = 'SET_SYNC_HISTORY_LOADING';
